<template>
<div class="card-parent">
  <el-card
    @click.native="openProperty(property)"
    class="property-card"
    style="border-radius: 13px"
  >
    
    <div class="clickable-card">
      
      <img class="image cardimg" :src="this.property.imageurl[0]" :alt="property.propertyname" />

    <el-row>
      <el-col :span="18">
        <h3 class="truncate-text" style="width: 280px; margin-top:0px; color: rgb(89, 89, 89);">{{ property.propertyname }}</h3>
      </el-col>
      <el-col :span="6">
        <PropertyOptionsPopup
          :property="property"
          v-on:delete-property="deleteProperty($event)"
          v-on:open-edit-property-form="emiteditproperty($event)"
        />
      </el-col>
    </el-row>

      <div style="text-align:left; padding-bottom: 10px; font-size: 18px; color: rgb(89, 89, 89);">
        <i class="el-icon-location"></i>
        {{ property.address }}
        <br />
        <i class="fas fa-toolbox"></i>
        Assets:{{ property.machinecount }}
      </div>
    </div>

    <div class="d-flex align-items-center" style="    font-size: 19px; padding-top: 4px;">
      <div>
        <div class="icon icon-xs icon-shape shadow rounded-circle text-black">
          
        </div>
      </div>

      <div>
        <span
          class="pl-2"
          :class="{'ownertitle' : this.user.firstname == this.property.ownerfirstname}"
        >
        <i class="fas fa-user-shield"></i>
          Owner:
          {{ property.ownerfirstname + " " + property.ownerlastname }}
        </span>
      </div>
    </div>
  </el-card>
</div>
</template>
<script>
import { mapState } from "vuex";
import PropertyOptionsPopup from "@/components/property/PropertyOptionsPopup";
// import "@/assets/sass/argon.scss";
// import "@/assets/css/nucleo/css/nucleo.css";
export default {
  components: {
    PropertyOptionsPopup
  },
  props: {
    property: Object,
    // eslint-disable-next-line vue/require-prop-type-constructor
    required: true
  },

  methods: {
    deleteProperty($event) {
      this.$emit("delete-property", $event);
    },
    updatePropertyLocally($event) {
      this.$emit("updated-property", $event);
    },
    openProperty(property) {
      console.log(property);
      this.$router.push({
        path: `PropertybyId/${property.propertyid}`,
        params: { property }
      });
    },
    emiteditproperty($event) {
      this.$emit("open-edit-property-form", $event);
    },
    emittedopenleavepropertyform($event) {
      this.$emit("open-leave-property-form", $event);
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  }
};
</script>
<style scoped>
.card {
  display: inline-block;
  color: black;
}
/*by @yuklfavish*/

.card-parent:hover{
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.card-parent{
    width: fit-content;
    height: fit-content;
    border-radius: 13px;
    margin: 30px 38px;
}
  .property-card{
      min-width:320px; 
      max-width: 335px; 
      margin: 0px; 
      border-radius: 13px; 
      padding: 0;  
      }

.mycardimg {
  width: 100%;
}

.cardimg {
  border-radius: 13px 13px 0px 0px;
  min-height: 210px;
  max-height: 210px;
  object-fit: cover;
     position: relative;
    left: -20px;
    right: -20px;
    width: calc(100% + 40px);
    top: -20px;
}

.clickable-card {
  cursor: pointer;
}
.ownertitle {
  color: #02746E;
}

@media (min-width: 250px) and (max-width: 979px) {
  .property-card{
    min-width: 280px;
    max-width: 280px;
  }
  .card-parent{
       min-width: 280px;
    max-width: 280px;
  }
}
</style>
